import { invokeWrapeeMethod, WrapeeMethod, WrapeeNotSupportedError } from './invokeWrapeeMethod';

export const getAppType = async () => {
	try {
		const deviceInfoResponse = await invokeWrapeeMethod(WrapeeMethod.getMobileMetrics);

		return deviceInfoResponse.appType; // Zwraca 'BuyerApp', 'SellerApp' lub inną wartość
	} catch (error) {
		if (!(error instanceof WrapeeNotSupportedError)) {
			console.error(error);
		}

		// Domyślne zachowanie, gdy 'wrapee' jest niezdefiniowane
		return 'default';
	}
};

export const isBuyerApp = async () => {
	const appType = await getAppType();
	if (appType && appType !== 'default') {
		return appType === 'BuyerApp';
	}
	// Zwraca wartość przechowywaną lokalnie, jeśli 'wrapee' jest niezdefiniowane
	return localStorage.getItem('isBuyerApp') === 'true';
};

export const isSellerApp = async () => {
	const appType = await getAppType();
	if (appType) {
		return appType === 'SellerApp';
	}
	// Zwraca wartość przechowywaną lokalnie, jeśli 'wrapee' jest niezdefiniowane
	return window.localStorage['IsApp'] === 'yes' && await isBuyerApp() === false;
};

export const checkAppVersion =  async () => {
	try {
		const deviceInfoResponse = await invokeWrapeeMethod(WrapeeMethod.getMobileMetrics);
		if (deviceInfoResponse?.appVersion) {
			return parseInt(deviceInfoResponse.appVersion.split('.')[0], 10);
		}
	} catch (error) {
		console.error('Error during getting app version:', error);
	}

	return 0;
}
